import * as React from 'react';
import { Preloader } from '@cian/preloader-component';
import * as styles from './OnlyForFairPlayersLoader.css';
import { OnlyForFairPlayersWrapper } from '../OnlyForFairPlayersWrapper';

export const OnlyForFairPlayersLoader = () => {
  return (
    <OnlyForFairPlayersWrapper className={styles['wrapper']}>
      <Preloader size={20} preloaderStyle={styles['loader']} />
    </OnlyForFairPlayersWrapper>
  );
};
